import CandidateListPage from './CandidateListPage';

export default CandidateListPage;